import { formatDate } from '@angular/common';
import { HttpClient, HttpEvent, HttpEventType, HttpHeaders, HttpRequest } from '@angular/common/http';
import { Component, ElementRef, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { Observable } from 'rxjs';
import { TerminoCondiciones } from 'src/app/models/mandatos-express/condiciones';
import { TerminoCondicionesFinal } from 'src/app/models/mandatos-express/condicionesFinal';
import { TerminoCondicionesRespuesta } from 'src/app/models/mandatos-express/condicionesRespuesta';
import { Estilos } from 'src/app/services/estilos/estilos';

const httpOptions = {
  headers: new HttpHeaders({
    'Content-Type': 'application/json',
    'Accept': 'application/json',
    'Access-Control-Allow-Methods': '*',
    'Access-Control-Allow-Origin': '*'
  })
};

export interface DialogData {
  terminoCondiciones: TerminoCondiciones;
  terminoCondicionesFinal : TerminoCondicionesFinal;
  isEmbebido: boolean;
}

@Component({
  selector: 'lib-condiciones-generales',
  templateUrl: './condiciones-generales.component.html',
  styleUrls: ['./condiciones-generales.component.css']
})
export class CondicionesGeneralesComponent {

  contenidoParam : TerminoCondiciones;
  contenidoParamFinal : TerminoCondicionesFinal;
  private apiUrl = "/apiMandatosMT/condicionesGenerales";
  private apiUrlFinal = "/apiMandatosMT/condicionesGeneralesFinal";

  private apiUrlPdf = "/apiMandatosMT/condicionesGenerales/pdf";
  private apiUrlPdfFinal ="/apiMandatosMT/condicionesGeneralesFinal/pdf"

  private apiUrlExpress = "/apiMandatosMT/condicionesGeneralesExpress";
  private apiUrlFinalExpress = "/apiMandatosMT/condicionesGeneralesFinalExpress";
  private apiUrlPdfFinalExpress ="/apiMandatosMT/condicionesGeneralesFinalExpress/pdf"

  html : string = "";
  idMandato : string = '0';
  isDataAvailable: boolean = false;
  isEmbebido: boolean = false;

  estilos : Estilos = new Estilos();

  constructor(
    public dialogRef: MatDialogRef<CondicionesGeneralesComponent>,
    private http: HttpClient,
    private elementRef: ElementRef,
    @Inject(MAT_DIALOG_DATA) public data: DialogData
  ) {
      this.estilos.cambioEstilos(elementRef);
      this.contenidoParam = data.terminoCondiciones;
      this.contenidoParamFinal = data.terminoCondicionesFinal;
      this.isEmbebido = data.isEmbebido;
    }

  ngOnInit(): void {
    let data: any;
    let api : string;
    if(this.contenidoParamFinal.idMandato != ''){
      this.idMandato = this.contenidoParamFinal.idMandato;
      api = this.isEmbebido ? this.apiUrlFinal : this.apiUrlFinalExpress;
      data = this.contenidoParamFinal;
    }else{
      api = this.isEmbebido ? this.apiUrl : this.apiUrlExpress;
      data = this.contenidoParam;
    }

    this.postGetTerminos(data, api).subscribe(data => {
        if(data.codResp = '0') {
          this.isDataAvailable = true;
          this.html = data.html;
        }
    });

  }

  postGetTerminos(body: any, api : string): Observable<TerminoCondicionesRespuesta> {
    return this.http.post<TerminoCondicionesRespuesta>(api, body, httpOptions);
  }

  downloadReportService(filtro: any,api : string): Observable<HttpEvent<Blob>> {
      return this.http.request(new HttpRequest(
        'POST',api , filtro,
        {
          reportProgress: true,
          responseType: 'blob'
        }));
  }

  public postDownloadReportFile(filtro: any) {
    let apiUrl = this.apiUrlPdf;
    if (this.idMandato != '0') {
      apiUrl = this.isEmbebido ? this.apiUrlPdfFinal : this.apiUrlPdfFinalExpress;
    }
    this.downloadReportService(filtro, apiUrl).subscribe(data => {
      if (data.type == HttpEventType.Response) {
        let downloadedFile: Blob;
        const a = document.createElement('a');
        a.setAttribute('style', 'display:none;');
        document.body.appendChild(a);
        downloadedFile = new Blob([data.body], { type: 'application/pdf;charset=utf-8' });
        a.download = 'Termino_Condiciones_' + formatDate(new Date(), 'yyyy/MM/dd', 'en') + '.pdf';
        a.href = URL.createObjectURL(downloadedFile);
        a.target = '_blank';
        a.click();
        document.body.removeChild(a);
      }
    },
      err => {
        console.log(err);
      }
    );
  }

    onNoClick(): void {
      this.dialogRef.close();
    }

    descargarPDF()
    {
      if(this.contenidoParamFinal.idMandato != '')
        {
          this.postDownloadReportFile(this.contenidoParamFinal);
        }else
        {
          this.postDownloadReportFile(this.contenidoParam);
        }
    }

}